import { ResultsPager } from "../../Wrap/Core/SortingAndPaging/ResultsPager";

import { BaseComponent } from "./BaseComponent";

import * as React from "react";

import { PagerLinks } from "./PagerComponents/PagerLinks";
import { PagerDropdown } from "./PagerComponents/PagerDropdown";
import { ResultsPerPage } from "./PagerComponents/ResultsPerPage";

export interface IPagerProps extends React.Props<Pager> {
    pager: ResultsPager;
    onChange: (recordsPerPage: number, pageIndex: number) => void;
    recordsPerPageOptions: number[];
    isShowPerPageOptions?: boolean;
}

export interface IPagerState {}

export class Pager extends BaseComponent<IPagerProps, IPagerState> {
    constructor(props: IPagerProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { pager, isShowPerPageOptions } = this.props;
        const showPages = pager.TotalPages > 1;
        const _isShowPerPageOptions = isShowPerPageOptions == true ? true : false;

        return (
            <>
            {showPages && (
                <div className="pagination">
                    <div className="row">
                            <div className="col-right col-auto col-bottom">
                                <PagerLinks
                                    onChange={(value) => this.props.onChange(this.props.pager.ResultsPerPage, value)}
                                    currentPage={this.props.pager.CurrentPage}
                                    numberOfPages={this.props.pager.TotalPages}
                                />
                            </div>
                            <div className="col-fluid col-bottom hidden-md-up">
                                <div className="pages-mobile">
                                    <PagerDropdown
                                        onChange={(value) => this.props.onChange(this.props.pager.ResultsPerPage, value)}
                                        currentPage={this.props.pager.CurrentPage}
                                        numberOfPages={this.props.pager.TotalPages}
                                    />
                                </div>
                            </div>

                        {_isShowPerPageOptions && (
                            <div className="col-fluid col-bottom">
                                <div className="per-page">
                                    <ResultsPerPage
                                        onChange={(value) => this.props.onChange(value, 1)}
                                        selectedValue={this.props.pager.ResultsPerPage}
                                        recordsPerPageOptions={this.props.recordsPerPageOptions}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                )}
            </>
        );
    }
}
